module.exports = __webpack_public_path__ + "static/img/call-pass.d80b4a61.png";